import { Box } from '@mui/material';

const fetchAcceptedWithConditions = ({
  ReadMoreText,
  MultiValueDisplay,
  formatDateTime,
  sp,
  currencyColor = '#ffffff',
}) => {
  const data = [];
  if (sp?.dispatchEvent?.serviceDate) {
    data.push({
      id: 'SERVICE_DATE',
      element: (
        <MultiValueDisplay title="Service Date:">
          {formatDateTime(
            sp?.dispatchEvent?.serviceDate,
            sp?.dispatchEvent?.serviceDateAfterHour,
            sp?.dispatchEvent?.serviceDateBeforeHour,
          )}
        </MultiValueDisplay>
      ),
    });
  }

  if (sp?.dispatchEvent?.additionalMoney > 0) {
    data.push({
      id: 'ADDITIONAL_MONEY',
      element: (
        <MultiValueDisplay
          type="currency"
          title="Additional Money:"
          sx={{ mb: 1 }}
          color={currencyColor}>
          {sp?.dispatchEvent?.additionalMoney}
        </MultiValueDisplay>
      ),
    });
  }

  if (sp?.dispatchEvent?.reason) {
    data.push({
      id: 'REASON',
      element: (
        <MultiValueDisplay title="Reason:" sx={{ mb: 1 }}>
          <ReadMoreText maxChars={250} allowExpand={false}>
            {sp?.dispatchEvent?.reason}
          </ReadMoreText>
        </MultiValueDisplay>
      ),
    });
  }

  if (sp?.dispatchEvent?.acceptedLocation?.locationName) {
    data.push({
      id: 'ACCEPTED_LOCATION',
      element: (
        <MultiValueDisplay title="Accepted Location:">
          {sp?.dispatchEvent?.acceptedLocation?.locationName}
        </MultiValueDisplay>
      ),
    });
  }

  return data?.map(d => (
    <Box key={d.id} sx={{ my: 0.5 }}>
      {d.element}
    </Box>
  ));
};

export default fetchAcceptedWithConditions;
